import { render } from "./BaseDropdownItem.vue?vue&type=template&id=646928e8"
import script from "./BaseDropdownItem.vue?vue&type=script&lang=js"
export * from "./BaseDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__